module.exports = __webpack_public_path__ + "static/media/csv.5e6a87d7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/attachment-icons/csv.svg
// module id = 1679
// module chunks = 17